const CLEANUP_INTERVAL = 1000;

interface PlacementItem {
	marker: {
		id: string;
	};
	placementIndex: number | undefined;
}

export class MarkerLabelPlacementCache {
	private readonly indices = new Map<string, number>();
	private lastCleanup = 0;

	get(id: string): number | undefined {
		return this.indices.get(id);
	}

	remember(id: string, placementIndex: number) {
		this.indices.set(id, placementIndex);
	}

	forget(id: string) {
		this.indices.delete(id);
	}

	drawInPlacementOrder<T extends PlacementItem>(items: T[], draw: (item: T) => void) {
		for (let i = items.length - 1; i >= 0; i--) {
			if (items[i].placementIndex != null) draw(items[i]);
		}
		for (let i = items.length - 1; i >= 0; i--) {
			if (items[i].placementIndex == null) draw(items[i]);
		}
	}

	cleanup(activeIds: Iterable<string>, now: number) {
		if (now - this.lastCleanup <= CLEANUP_INTERVAL) return;
		this.lastCleanup = now;

		const activeIdSet = activeIds instanceof Set ? activeIds : new Set(activeIds);
		for (const id of this.indices.keys()) {
			if (!activeIdSet.has(id)) {
				this.indices.delete(id);
			}
		}
	}
}